import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DEFAULT_OPTIONS, type GameOptions } from '@durak/shared';

interface State {
  opts: GameOptions;
  set: (partial: Partial<GameOptions>) => void;
  reset: () => void;
}

/**
 * The player's preferred room rules, persisted across sessions in localStorage.
 * Used as the default when creating a new game; the user's last choices come
 * back the next time they open the create-room panel.
 */
export const useGameOptions = create<State>()(
  persist(
    (set) => ({
      opts: DEFAULT_OPTIONS,
      set: (partial) => set((s) => ({ opts: { ...s.opts, ...partial } })),
      reset: () => set({ opts: DEFAULT_OPTIONS }),
    }),
    { name: 'durak-game-options', version: 1 },
  ),
);
